<template>
	<div class="main-checkcout">
		<transition name="checkout-anim"  enter-active-class="animate__animated animate__backInUp" leave-active-class="animate__animated animate__backOutDown">
			<gift 
			v-if="show_gift"
			@giftProduct="form.gift = $event; form.status_gift = true; show_gift = false;"
			@closeGift="form.status_gift = $event; show_gift = false;">
			</gift>
		</transition>
		<div class="map-ubication-container" v-show="visible_map">
	        <div class="map-container" id="map3">
	          
	        </div>
	        <div class="detail-direction">
	            <div class="close-detail">
	              <i class="fas fa-times" @click="closeMap()"></i>
	            </div>
	            <div class="input-complete">
	              <input type="text" placeholder="Ingrese la dirección" id="complete_direction_ecommerce">
	            </div>
	            <div class="actual-position-container" @click="SetcurrentPosition()">
	              <div class="position-icon">
	                <i class="fa fa-map-marker-alt"></i>
	              </div>
	              <div class="position-text">
	                <h4>Ubicación actual</h4>
	                <input type="text" name="" v-model="actual_ubication">
	              </div>
	              <div class="position-circle">
	                <div class="circle">
	                  <div class="esfere">
	                    
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="ubication-warning" v-if="out_zone">
	              <span>Estás por fuera de las zonas de entrega</span>
	            </div>
	            <div class="ubication-warning" v-if="empty_map_fields">
	              <span>Debe especificar una dirección</span>
	            </div>
	            <div class="button-direction-container">
	              <button v-bind:style="{backgroundColor : color_botones}" @click="validatePosition()" id="id_btn_confirmar">Confirmar dirección</button>
	            </div>
	        </div>
      	</div>	
		<div class="content-checkout" v-show="!show_gift">
			<div class="header-checkout">
				<h4>Checkout</h4>
			</div>
			<div class="delivery-options" v-show="recoger">
				<button @click="domicilio()" class="domi">Domicilio</button>
				<button @click="recogerlo()" class="recoger">Recogerlo</button>
			</div>
			<div class="validate" v-show="statusValidation">
				<strong>Campos Requeridos *</strong>
			</div>
			<div class="person-data">
				<div class="payments-ways" id="id_point">
					<div class="payment-icon">
						<i class="fa fa-home"></i>
					</div>
					<div class="payment-select">
						<select name="select" v-model="form.id_point" @change="seleccion">
						<option value="0" disabled selected>Seleccione un punto</option>
						<option :value="point.id_point" v-for="point in points">{{ point.name }}</option>
						</select>
					</div>
				</div>
				<div class="personal-data">
					<input type="text" class="data-name" id="nombre" v-model="form.nombre" placeholder="Nombres">					
					<input type="text" class="data-phone" id="telefono" v-model="form.telefono" placeholder="Teléfono">
				</div>
				<!--<input type="date" class="data-nacimiento fecha_entrega_2" v-model="form.fecha_nacimiento" placeholder="Fecha de nacimiento" autocomplete="off" v-show="born_date" onchange="this.className=(this.value!=''?'has-value':'')">-->

				<input type="text" class="data-nacimiento" id="nacimiento" v-model="form.fecha_nacimiento" placeholder="Fecha de nacimiento" autocomplete="off" v-show="born_date">

				<!--<input type="date" class="data-nacimiento fecha_entrega_2" v-model="form.fecha_entrega" placeholder="Fecha de entrega" autocomplete="off" v-show="deliver_date && !delivery_time" onchange="this.className=(this.value!=''?'has-value':'')">-->

				<input type="text" class="data-nacimiento" id="fecha_entrega" v-model="form.fecha_entrega" placeholder="Fecha de entrega" autocomplete="off" v-show="deliver_date && !delivery_time">

				<!--<input type="date" class="data-nacimiento fecha_entrega" v-model="form.fecha_entrega" placeholder="Fecha de entrega" autocomplete="off" v-show="delivery_time" onchange="this.className=(this.value!=''?'has-value':'')" :min="min_date">-->

				<input type="text" class="data-nacimiento" id="fecha_entrega_2" v-model="form.fecha_entrega" placeholder="Fecha de entrega" autocomplete="off" v-show="delivery_time">

				<input type="text" class="data-email" id="email" v-model="form.email" placeholder="Correo electronico" v-if="email_company">

				<input type="text" class="data-cedula" id="cedula" v-model="form.cedula" placeholder="Cédula" v-if="cedula_company">
				<input type="text" class="data-address" id="direccion" v-show="!status_recogerlo" v-model="form.direccion" placeholder="Dirección">
				<div class="payments-ways" id="ciudad_entrega" v-show="ciudades_entrega.length > 0">
					<div class="payment-icon">
						<i class="fas fa-city"></i>
					</div>
					<div class="payment-select" >
						<select name="select" v-model="ciudad_entrega">
						  <option value="0" disabled selected>Ciudad de entrega</option>
						  <option v-for="(city,index) in ciudades_entrega" :key="index" :value="city.ciudad"> {{ city.ciudad}}</option>
						</select>
					</div>
				</div>
				<div class="payments-ways" id="forma_pago">
					<div class="payment-icon">
						<i class="fas fa-money-bill"></i>
					</div>
					<div class="payment-select">
						<select name="select" v-model="form.forma_pago" @change="verifyPayment()">
						  <option value="0" disabled selected>Método de pago</option>
						  <option value="37" v-if="cash">Efectivo</option>
						  <option value="38" v-if="transfer">Transferencia</option>
						  <option value="39"  v-if="dataphone">Datáfono</option>
						  <option value="40"  v-if="status_contraentrega">Contra entrega</option>
						  <option value="76" v-if="status_pay_online">Pago en linea</option>
						</select>
					</div>
				</div>

				<div class="bank-account" v-show="bank_transfer && bank_account.length > 0">
					<div class="account-select">
						<select name="select" id="select-bank" @change="copyAccount()">
						  <option value="0" disabled selected>Seleccione para copiar N° de cuenta</option>
						  <option :value="bank.account" v-for="bank in bank_account" :key="bank.id">{{ bank.bank }}</option>
						</select>
					</div>
				</div>
				<div style="margin-top: 10px;text-align: left">
				        <label class="style-account" id="notify-copy">Número de cuenta copiado!</label>
				</div>
				<input type="text" v-model="form.comentario" class="data-observation" placeholder="Comentario">
			</div>
			<div class="gift-content">
				<div class="inputGroup" @click="show_gift = true">					
	   				<input id="option1" v-model="form.status_gift" type="checkbox"/>
	   				<label for="option1">¿Lo enviarás a otra persona?</label>
  				</div>
  				<!--<button @click="show()">Mostrar</button>-->
			</div>
			<div class="order-discount">
				<!--Incluimos la sección de añadir cupon-->
				<div class="name-cupon">
					<h3>¿Quieres usar cupón?</h3>
					<h4 @click="status_coupon = true">Usar cupón</h4>
				</div>
				<div class="detail-cupon" v-show="status_coupon">
					<div class="check-image">
						<i class="fas fa-check"></i>
						<i class="fas fa-times"></i>
						<i class="fas fa-spinner"></i>
					</div>
					<div class="input-cupon">
						<input type="text" placeholder="Código...." v-model="coupon_value">
					</div>
					<div class="send-cupon">
						<i class="far fa-paper-plane" @click="ValidateCoupon()"></i>
						<i class="fas fa-times" @click="clearAll()"></i>
					</div> 
				</div>
				<div class="status-text">
					<h4 class="status-cop">{{ couponText }}</h4>
				</div>
				<div class="total-items">
					<h4>{{ list_cart.length }} items</h4>
					<h4>$ {{ Intl.NumberFormat("de-DE").format(subtotal) }}</h4>
				</div>
				<div class="deliver" v-if="valor_domicilio > 0">
					<h4>Domicilio:</h4>
					<h4>$ {{ Intl.NumberFormat("de-DE").format(valor_domicilio) }}</h4>
				</div>
				<div class="cupon-discount" v-show="form.descuento > 0">
					<h4>Descuento:</h4>
					<h4>$ {{ Intl.NumberFormat("de-DE").format(form.descuento) }}</h4>
				</div>
				<div class="order-total">
					<h4>Total:</h4>
					<h4>$ {{ Intl.NumberFormat("de-DE").format(total_order) }}</h4>
				</div>
				<div class="send-data" v-if="!checkout">
					<button @click="saveOrder(false)"><i class="fab fa-whatsapp"></i>Enviar a WhatsApp</button>
				</div>
				<div v-show="checkout" style="width: 100%;">    
      				<button class="btn-wonpi" @click="pay()">Paga Aquí</button>     
    			</div>
				<!--<div class="container-button">
					<div class="send-button">
						<i class="fas fa-check hide"></i>
						<i class="fab fa-whatsapp what"></i>
						<label class="send-text">Enviar a WhatApp</label>
					</div>
				</div>-->
				<div class="back-to-cart">
					<button  @click="close()"><i class="fas fa-long-arrow-alt-left"></i>Volver al carrito</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>

	*:focus{
		outline:none;
	}






	.close-detail{
	    width: 100%;
	    text-align: right;
	    padding: 7px 8px;
	  }

	  .close-detail i{
	    font-size: 21px;
	    color: #DEE1E6;
	  }

	.ubication-warning{
	    width: 100%;
	    text-align: center;
	    padding: 5px;
	  }

	  .ubication-warning span{
	    font-size: 15px;
	    color: red;
	    font-weight: 500;
	  }

	  .button-direction-container{
	    width: 100%;
	    padding-top: 15px;
	    text-align: center;
	  }

	  .button-direction-container button{
	    padding: 9px 21px;
	    color: #fff;
	    font-weight: 500;
	    font-size: 17px;
	    border-radius: 6px;
	    border: none;
	  }

	.detail-direction{
	    width: 100%;
	    height: auto;
	    padding: 5px;
	  }

	  .input-complete{
	    width: 97%;
	    margin: 0 auto;
	  }

	  .input-complete input{
	    width: 100%;
	    background: #F1F3F4;
	    color: #3A3A3A;
	    font-size: 16px;
	    padding: 14px 13px;
	    border: none;
	    border-radius: 7px;
	    margin-bottom: 10px;
	  }

	  .actual-position-container{
	    width: 97%;
	    margin: 0 auto;
	    border: 1px solid #ddd;
	    padding: 10px 5px;
	    border-radius: 8px;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	  }

	  .position-icon{
	    width: 10%;
	    text-align: center;
	  }

	  .position-icon i{
	    font-size: 22px;
	    color: #003466;
	  }

	  .position-text{
	    width: 82%;
	    text-align: left;
	    padding: 0px 6px;
	  }

	  .position-text h4{
	    margin-bottom: 0;
	    font-size: 16px;
	    font-weight: 500;
	  }

	  .position-text input{
	    border: none;
	    width: 100%;
	    font-size: 15px;
	    color: #DEE1E6;
	  }

	  .position-circle{
	    width: 8%;
	    text-align: center;
	  }

	  .border{
	    border: 1px solid #003466 !important;
	  }

	  .blue-color{
	    background: #003466 !important;
	  }

	  .circle{
	    width: 22px;
	    height: 22px;
	    border-radius: 50%;
	    border: 1px solid #EBEBEB;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	  }

	  .esfere{
	    width: 14px;
	    height: 14px;
	    border-radius: 50%;
	    background: #EBEBEB;
	  }


	.map-ubication-container{
	    width: 100%;
	    height: 100vh;
	    background: #fff;
	    display: block;
	    position: fixed;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    right: 0;
	    z-index: 1000;
	}

	.map-container{
	    width: 100%;
	    height: 55vh;
	    border: 1px solid #ddd;
	}


	@media only screen and (min-width: 355px) and (max-width: 400px){
	    .map-container{
	      height: 45vh;
	    }
	}

	.btn-wonpi{
      	display: inline-block;
      	background-color: rgb(26, 69, 148);
      	border: 0px;
      	border-radius: 10px;
      	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
      	font-weight: 600;
      	font-size: 16px;
      	border-top-left-radius: 22px;
	  	border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border-top-right-radius: 0 !important;
		padding: 11px;
      	color: white;
      	cursor: pointer;
      	-webkit-font-smoothing: subpixel-antialiased;
      	width: 100%;
      	margin-top:10px;
  	}

	.btn-wonpi::before {
	    content: "";
	    display: inline-block;
	    width: 16px;
	    height: 16px;
	    background-image : url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 229.5 229.5'%3E%3Cpath fill='%23fff' d='M214.419 32.12A7.502 7.502 0 0 0 209 25.927L116.76.275a7.496 7.496 0 0 0-4.02 0L20.5 25.927a7.5 7.5 0 0 0-5.419 6.193c-.535 3.847-12.74 94.743 18.565 139.961 31.268 45.164 77.395 56.738 79.343 57.209a7.484 7.484 0 0 0 3.522 0c1.949-.471 48.076-12.045 79.343-57.209 31.305-45.217 19.1-136.113 18.565-139.961zm-40.186 53.066l-62.917 62.917c-1.464 1.464-3.384 2.197-5.303 2.197s-3.839-.732-5.303-2.197l-38.901-38.901a7.497 7.497 0 0 1 0-10.606l7.724-7.724a7.5 7.5 0 0 1 10.606 0l25.874 25.874 49.89-49.891a7.497 7.497 0 0 1 10.606 0l7.724 7.724a7.5 7.5 0 0 1 0 10.607z'/%3E%3C/svg%3E");
	    background-size:contain;
	    background-repeat: no-repeat;
	    vertical-align: middle;
	    margin-right: 8px;
	    transform: translateY(-2px);
	}

	.selected-button{
		background: #12243C !important;
		color: #fff !important;
	}

	.delivery-options{
		width: 93%;
		margin: 0 auto;
		padding: 10px 0px;
		display: flex;
		justify-content: center;
		/*border-bottom: 1px solid #ACACAC;*/
		margin-bottom: 8px;
	}

	.delivery-options button{
		width: 40%;
		margin-right:10px;
		padding: 6px 0px;
		border: 2px solid #12243C;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border-top-left-radius: 22px;
	}

	.chose{
		background: #12243C;
		color: #fff;
	}

	.animation{
		animation: girar 2s infinite;
	}

	@keyframes girar {
		from{
			transform: rotate(0deg);
		}
		to{
			transform: rotate(360deg);	
		}
	}

	.success-coupon{
		background-color: #0DC142 !important;
	}

	.wrong-coupon{
		background-color: red !important;
	}

	.name-cupon{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 10px;
	}

	.status-text{
		width: 100%;
		text-align: center;
		padding-bottom: 10px;
	}

	.status-text h4{
		font-size: 15px;
		font-weight: 500;
	}

	.red{
		color: red !important;
	}

	.green{
		color: #0DC142 !important;
	}
	.name-cupon h3{
		font-size: 16px;
		font-weight: 500;
	}

	.name-cupon h4{
		font-size: 15px;
		font-weight: 500;
		text-decoration: underline;
	}

	.detail-cupon{
		width: 97%;
		display: flex;
		justify-content: flex-start;
		margin: 0 auto;
		align-items: center;
		padding:3px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		border-top-left-radius: 30px;
		margin-bottom: 10px;
		border: 2px solid #12243C;
		background: #fff;
	}

	.check-image{
		width: 40px;
		height: 40px;
		border-radius:50%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #12243C;
	}

	.check-image i{
		color: #fff;
		font-size: 16px;
	}

	.input-cupon{
		width: 75%;
		text-align: center;
	}

	.input-cupon input{
		background: transparent;
	}

	.input-cupon input{
		height: 30px;
		font-size: 17px;
		border:none;
		padding-left: 10px;
	}

	.send-cupon i{
		color: #12243C;
	}

	.style-account{
		color: #12243C;
		display: none;
		font-size: 16px;
		font-weight: 500;
		margin-left: 10px;
	}

	/*input[type="date"]:not(.has-value):before{
		width: 100% !important;
  		color: #757575;
 		content: attr(placeholder);
	}

	input[type="date"].has-value{
		margin-top:10px;
  		width:100% !important;
	}*/

	/*@media only screen 
	  and (min-device-width: 375px) 
	  and (max-device-width: 667px) 
	  and (-webkit-min-device-pixel-ratio: 2) { 
	  	.fecha_entrega{
	  		width: 100vw !important;
	  		-webkit-appearance: none !important;
		}

		.fecha_entrega_2{
	  		width: 100vw !important;
	  		-webkit-appearance: none !important;
		}

		input[type="date"]:not(.has-value):before{
	 		content: attr(placeholder);
	 		width: 100vw !important;
		}
	}

	.fecha_entrega{
		-webkit-appearance: none !important;
	}

	.fecha_entrega_2{
		-webkit-appearance: none !important;
	}*/

	.gift-content{
		width:100%;
		justify-content:flex-end;
		align-items:center;
	}	

	.inputGroup {
	    background-color: #F0F5F9;
	    display: block;
	    margin: 0;
	    position: relative;
	    width: 85%;
	    label {
	      padding: 12px 30px;
	      width: 100%;
	      display: block;
	      text-align: left;
	      color: #3C454C;
	      font-size: 16px;
	      font-family: 'Poppins', sans-serif;
	      cursor: pointer;
	      position: relative;
	      z-index: 2;
	      transition: color 200ms ease-in;
	      overflow: hidden;

	      &:before {
	        width: 10px;
	        height: 10px;
	        border-radius: 50%;
	        content: '';
	        background-color: #5562eb;
	        position: absolute;
	        left: 50%;
	        top: 50%;
	        transform: translate(-50%, -50%) scale3d(1, 1, 1);
	        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
	        opacity: 0;
	        z-index: -1;
	      }

	      &:after {
	        width: 32px;
	        height: 32px;
	        content: '';
	        border: 2px solid #D1D7DC;
	        background-color: #fff;
	        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
	        background-repeat: no-repeat;
	        background-position: 2px 3px;
	        border-radius: 50%;
	        z-index: 2;
	        position: absolute;
	        right: 10px;
	        top: 50%;
	        transform: translateY(-50%);
	        cursor: pointer;
	        transition: all 200ms ease-in;
	      }
	    }

	    input:checked ~ label {
	      color: #000;

	      &:before {
	        transform: translate(-50%, -50%) scale3d(56, 56, 1);
	      }

	      &:after {
	        background-color: #54E0C7;
	        border-color: #54E0C7;
	      }
	    }

	    input {
	      width: 32px;
	      height: 32px;
	      order: 1;
	      z-index: 2;
	      position: absolute;
	      right: 30px;
	      top: 50%;
	      transform: translateY(-50%);
	      cursor: pointer;
	      visibility: hidden;
	    }
  }


	.container-button{
		width: 100%;
		padding: 10px 0px 10px 0px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.send-button{
		width: 100%;
		background: #0DC142;
		padding: 13px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		transition: all 1s;
	}

	.send-button label{
		color: #fff;
		margin-bottom: 0 !important;
	}

	.send-button i:nth-child(1){
		color: #0DC142;
	}

	.send-button i:nth-child(2){
		color: #fff;
		margin-right: 3px;
	}

	.button-loading{
		width: 50px;
		height: 50px;
		border: 2px dashed #0DC142;
		background: #fff;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: all 1s;
	}

	.hide{
		display: none;
	}

	.rodar{
		animation: rodar 2s linear infinite;
	}

	@keyframes rodar {
		100%{
			transform: rotate(360deg);
		}
	}
	.validate{
		width: 100%;
		padding: 5px 25px 5px 25px;
		font-size: 12px;
		color: red;
		text-align: left;
	}
	.empty-shield{
		border: 2px solid red !important;
	}
	.red{
		color: red;
	}
	.content-checkout{
		width: 100%;
		height: auto;
		background: #F0F5F9;
	}

	.header-checkout{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		padding: 20px 25px 0px 25px;
	}

	.header-checkout h4 {
		font-size: 26px;
		font-weight: 700;
		letter-spacing: 1px;
		margin-bottom: 0 !important;
	}

	.person-data{
		width: 100%;
		height: auto;
		padding: 25px 10px 25px 10px;
	}

	.custom-content{
		border-top: 1px solid #ACACAC;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
	}

	.personal-data{
		width: 100%;
		height: auto;
		margin-top: 15px;
		display: flex;
		justify-content: space-between;
	}

	.person-data input{
		padding: 12px;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		border: 2px solid #12243C;
		background: #f3f3f3;
	}

	.person-data input:focus{
		outline: none;
	}

	.data-name{
		width: 49%;
	}

	.data-phone{
		width: 49%;
	}

	.data-address, .data-cedula, .data-email, .data-nacimiento{
		width: 100%;
		margin-top: 15px;
	}

	.data-observation{
		width: 100%;
		height: 70px;
		margin-top: 15px;
	}

	.order-discount{
		width: 100%;
		padding: 27px 30px 20px 30px;
		border-top-left-radius: 20px;
		background: #fff;
		box-shadow: 0px -6px 15px 0px rgba(240,240,240,1);
	}

	.total-items, .deliver, .cupon-discount{
		width: 100%;
		padding-bottom: 9px;
		display: flex;
		justify-content: space-between;
	}

	.order-total{
		display: flex;
		justify-content: space-between;
		padding-top: 10px;
		border-top: 1px dotted #12243C;
	}

	.order-discount h4{
		margin-bottom: 0 !important;
	}

	.total-items h4{
		font-size: 16px;
		color: #646464;
	}

	.deliver h4{
		font-size: 16px;
		color: #646464;
	}

	.cupon-discount h4{
		font-size: 16px;
		color: #646464;
	}

	.order-total h4{
		font-size: 19px;
	}

	.send-data{
		width: 100%;
		padding-top: 20px;
	}

	.send-data button{
		width: 100%;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		padding: 13px;
		font-size: 17px;
		font-weight: 600;
		color: #fff;
		background: #0DC142;
		border: none;
		box-shadow: 0px 0px 14px 0px rgba(219,219,219,1);
	}

	.send-data button:focus{
		outline: none;
	}

	.send-data i{
		padding-right: 10px;
		color: #fff;
	}

	.back-to-cart{
		width: 100%;
		padding-top: 10px;
	}

	.back-to-cart i{
		padding-right: 10px;
		color: #12243C;
	}

	.back-to-cart button{
		width: 100%;
		border-top-left-radius: 22px;
		border-bottom-right-radius: 22px;
		border-bottom-left-radius: 22px;
		padding: 11px;
		font-size: 17px;
		font-weight: 600;
		color: #12243C;
		background: #fff;
		border: 2px solid #12243C;
	}

	.back-to-cart button{
		outline: none;
	}

	.payments-ways{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #f3f3f3;
		border-top-left-radius: 30px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		border: 2px solid #12243C;
		padding: 4px;
		margin-top: 15px;
	}

	.bank-account{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background: #f3f3f3;
		border-top-left-radius: 30px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		border: 2px solid #12243C;
		padding: 4px;
		margin-top: 15px;
	}

	.payment-icon{
		width: 46px;
		height: 46px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #12243C;
	}

	.payment-icon i{
		color: #fff;
	}

	.payment-select{
		width: 90%;
	}

	.account-select{
		width: 100%;
	}

	.account-select select{
		width: 100%;
		color: #12243C;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 19px;
		cursor: pointer;
		color: #757575;
		background: transparent;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	}

	.payment-select select{
		width: 100%;
		color: #12243C;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 19px;
		cursor: pointer;
		color: #757575;
		background: transparent;
		border: none;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	}

	.payment-select select:focus{
		outline: none;
	}

	.account-select select:focus{
		outline: none;
	}
</style>

<script>
	import axios from 'axios';
	import $ from 'jquery';
	import Gift from './Gift';
	import moment from 'moment';
	import { osName } from 'mobile-device-detect';
	export default {
		components:{
			Gift
		},
		data(){
			return {
				min_date: "",
				ciudades_entrega: JSON.parse(localStorage.getItem('ciudades_entrega')),
				ciudad_entrega: 0,
				hora_actual: moment().format('HH'),
				delivery_time: JSON.parse(localStorage.getItem('delivery_time')),
				id_zone: 0,
				zone_name: "",
				empty_map_fields: false,
				out_zone: false,
				actual_ubication: "Calculando...",
				place_aux: "",
				map_contador: 0,
				status_current_position: false,
				visible_map: false,
				nameOS: osName,
				color_botones: localStorage.getItem('color_licencia'),
				status_map: JSON.parse(localStorage.getItem('status_map')),
				address: localStorage.getItem('direccion'),
				recoger: JSON.parse(localStorage.getItem('btn-recogerlo')),
				status_coupon: false,
				born_date: JSON.parse(localStorage.getItem('fecha_nacimiento')),
				deliver_date: JSON.parse(localStorage.getItem('fecha_entrega')),
				color_licencia: localStorage.getItem('color_licencia'),
				bank_transfer: false,
				bank_account: JSON.parse(localStorage.getItem('banks_accounts')),
				status_pay_online: JSON.parse(localStorage.getItem('status_pay_online')),
				status_contraentrega: JSON.parse(localStorage.getItem('contraentrega')),
				show_gift : false,
				statusValidation: false,
				email_company: false,
				cedula_company: false,
				cash: false,
				transfer: false,
				dataphone: false,	
				list_cart: JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`)),
				total_order: 0,
				subtotal: 0,
				valor_domicilio: parseFloat(localStorage.getItem('Domicilio')),
				latitude: 'No',
				longitude: 'No',
				points: [],
				form:{
					nombre: '',
					cedula: '',
					email: '',
					fecha_nacimiento: '',
					fecha_entrega: '',
					telefono: '',
					direccion: '',
					forma_pago: 0,					
					comentario: '',
					cart: [],
					domicilio: 0,
					descuento: 0,
          			id_coupon: "",
					id_companie : localStorage.getItem('id_companie'),
					status_gift: false,
					gift: null,
					id_point: 0
				},
				checkout: false,        
		        formPay:{
		          id_order: false,
		          payOnline: false,
		          wompiPublicKey: '',
		          wompiCurrency: '',
		          wompiReference: '',
		          redirectUrl: ''
		        },
				url_imagen: "",
				mensaje: "",
				telefono_pedidos: "",
				formasPago:[
		          {id: 37, text: 'Efectivo'},
		          {id: 38, text: 'Transferencia'},
		          {id: 39, text: 'Datáfono'},
		          {id: 40, text: 'Contra entrega'},
		          {id: 76, text: 'Pago en linea'},
		        ],
		        couponSuccess: false,
		        couponError: false,
		        couponText: '',
				coupon:{
		          id_companie: "",
		          id_coupon: "",
		          coupon: "",
		          phone: "",
		          total: "",
		          cart: []
		        },
		        coupons: false,
		        coupon_value: "",
		        domi_aux: 0,
		        status_recogerlo: false
			}
		},
		watch: {
			/*"form.status_gift": function(val){
				this.show_gift = val;
				if(!val)this.form.gift = null;
			}*/
		},
		methods:{
			seleccion(){
				const puntoSeleccionado = this.points.find(point => point.id_point === this.form.id_point);

				if (puntoSeleccionado) {
				this.telefono_pedidos = puntoSeleccionado.telefono_pedidos;
				} else {
				// Si no se encuentra el punto seleccionado, puedes manejarlo según tus necesidades
				console.warn('No se encontró el punto seleccionado con el id_point:', this.form.id_point);
				}
				console.log('Opción seleccionada:', this.form.id_point);
			},
			openMapDetail(){
		      var self = this;
		      if (this.status_map) {
		        this.form.domicilio = 0;
		        if(!this.status_recogerlo){
		          if (this.latitude == 'No'  && this.longitude == 'No') {
		            this.visible_map = true;   
		            const ubicacion_success = function(ubicacion) {
		              if (ubicacion) {
		                const lat = ubicacion.coords.latitude;
		                const lng = ubicacion.coords.longitude;        
		                self.latitude = lat;
		                self.longitude = lng;
		                self.setDirection(self.latitude, self.longitude);
		              }
		            }
		            const ubicacion_error = function(error) {          
		              console.log(error)
		            }   
		            //solo para domicilios
		            if(navigator.geolocation) {
		              navigator.geolocation.getCurrentPosition(ubicacion_success,ubicacion_error);
		            }
		          }
		        } 
		      }
		    },
		    setDirection(latitude, longitude){
		      var self = this;
		      var Http = new XMLHttpRequest();
		      var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=AIzaSyAZVmTOt9PmUdHQ1lYyCdWvKKM8OOJqavc';
		      Http.open('POST', url);
		      Http.send();
		      Http.onreadystatechange = (e) => {
		        var arreglo = JSON.parse(Http.responseText);
		        var resultado = arreglo.results[0];
		        self.actual_ubication = resultado.formatted_address;
		        self.place_aux = arreglo.results[0];
		      }
		    },
			setDevileryCost(id_companie, latitud, longitud){
		      axios.get('https://back.vinapp.co/api/get-address/'+id_companie+'/'+latitud+'/'+longitud) 
		       .then(res => {
		        var self =this;
		          if (res.data.sql == 0) {
		            this.out_zone = true;
		            this.valor_domicilio = 0;
		            //this.delivery_message = true;
		            setTimeout(function(){
		              self.out_zone = false;
		            },2000);
		          }else{
		            this.valor_domicilio = 0;
		            this.id_zone = res.data.sql.id_zone;
		            this.zone_name = res.data.sql.name;
		            this.valor_domicilio = parseFloat(res.data.sql.cost);
		            //this.total_order+= this.valor_domicilio;
		          }    
		          this.setTotalOrder();
		       })
		       .catch(err => {
		          console.log(err);      
		       });
		    },
			setAdrress(place){
		      var self = this;
		      var geocoder = new google.maps.Geocoder();
		      geocoder.geocode({address: place}, function(results, status) {
		        if (status === google.maps.GeocoderStatus.OK) {
		          var result = results[0].geometry.location; // el primer resultado es el más relevante
		          console.log(results);
		          self.latitude = result.lat();
		          self.longitude = result.lng();
		          self.setDevileryCost(self.form.id_companie, self.latitude, self.longitude);
		        } else {
		          console.log('Google respondió:',status);
		        }
		      });
		    },
			validatePosition(){
		      var self = this;
		      let autocomplete = document.getElementById('complete_direction_ecommerce').value;
		      if (autocomplete != "" || this.status_current_position) {
		        if (autocomplete != "") {
		          this.form.direccion = autocomplete;
		          this.visible_map = false;
		        }
		        if (this.status_current_position) {
		          this.form.direccion = this.actual_ubication;
		          this.visible_map = false;
		        }
		      }else{
		        this.empty_map_fields=true;
		        setTimeout(function(){
		          self.empty_map_fields=false;
		        },2000);
		      }
		    },
			initMap(){
		      var self = this;
		      const componentForm = [
		        'location',
		        'locality',
		        'administrative_area_level_1',
		        'country',
		        'postal_code',
		      ];
		      var bounds = new google.maps.LatLngBounds();
		      //lat: 10.471864459868115, lng: -73.26583531981072
		      // Creamos el mapa
		      var map = new google.maps.Map(document.getElementById('map3'), {
		        zoom: 13.8,
		        mapTypeControl: false,
		        fullscreenControl: false,
		        center: {lat: 10.471864459868115, lng: -73.26583531981072}, // Centramos el mapa al area
		        mapTypeId: 'terrain',
		      });
		      var options = {
		        //types: ['establishment'],
		        componentRestrictions: {country: "co"}
		      };

		      const marker = new google.maps.Marker({map: map, draggable: false});
		      const autocompleteInput = document.getElementById('complete_direction_ecommerce');
		      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput, options);

		      autocomplete.addListener('place_changed', function () {
		        marker.setVisible(false);
		        const place = autocomplete.getPlace();
		        if (!place.geometry) {
		          // User entered the name of a Place that was not suggested and
		          // pressed the Enter key, or the Place Details request failed.
		          window.alert('Sin detalles disponibles para: \'' + place.name + '\'');
		          return;
		        }
		        var drinkSelect = document.getElementById('id_btn_confirmar');
				setTimeout(function(){
		         drinkSelect.disabled = false; 
		        }, 500);
		        self.renderAddress(map,marker,place);
		        self.setAdrress(place.formatted_address);
		        //self.fillInAddress(place, componentForm);
		        //self.getCoordinates(place.name);
		      });
		    },
			renderAddress(mapa, marker, place){
		      mapa.setCenter(place.geometry.location);
		      marker.setPosition(place.geometry.location);
		      marker.setVisible(true);
		    },
			SetcurrentPosition(){
		      if (this.map_contador == 0) {
		        $(".esfere").show();
		        $(".esfere").addClass("blue-color");
		        $(".actual-position-container").addClass("border");
		        $(".circle").addClass("border");
		        //creamos la instacia del mapa y el marcador para redigir la posicion en el mapa cuando en usuario seleccione su ubicacion actual
		        var map = new google.maps.Map(document.getElementById('map3'), {
		          zoom: 13.8,
		          mapTypeControl: false,
		          fullscreenControl: false,
		          center: {lat: 10.471864459868115, lng: -73.26583531981072}, // Centramos el mapa al area
		          mapTypeId: 'terrain',
		        });
		        const marker = new google.maps.Marker({map: map, draggable: false});
		        this.renderAddress(map, marker, this.place_aux);
		        this.map_contador++;
		        this.status_current_position = true;
		        this.setDevileryCost(this.form.id_companie, this.latitude, this.longitude);
		      }else{
		        $(".esfere").hide();
		        $(".esfere").removeClass("blue-color");
		        $(".actual-position-container").removeClass("border");
		        $(".circle").removeClass("border");
		        this.map_contador = 0;
		        this.status_current_position = false;
		      }
		    },
			closeMap(){
		      let autocomplete = document.getElementById('complete_direction_ecommerce').value;
		      if (autocomplete == "" || !this.status_current_position) {
		        this.visible_map = false;
		        this.latitude = 'No';
		        this.longitude = 'No';
		      }else{
		        this.visible_map = false;
		      }
		    },
			getListPoints(){
				var self = this;
				axios 
				.get('https://back.vinapp.co/api/points/list-points/'+this.form.id_companie)
			    .then( res =>{
					this.points = res.data;
					console.log(this.points);
				})
				.catch( err => {
			      console.log(err);
			    });
			},
			pay(){
			    if(!this.validateShields()) return 0;   
			    var self = this;
			    axios
			    .get('https://back.vinapp.co/api/order/get-data-wompi/'+this.form.id_companie)
			    .then( res =>{
			      this.formPay.wompiPublicKey = res.data.wpk;
			      this.formPay.wompiCurrency = res.data.wc;
			      this.formPay.wompiReference = res.data.wr;
			      this.formPay.redirectUrl = res.data.wp_redirect_url;
			      self.checkout = new WidgetCheckout({
			        currency: self.formPay.wompiCurrency,
			        amountInCents: parseFloat(String(self.total_order)+'00'),
			        reference: self.formPay.wompiReference,
			        publicKey: self.formPay.wompiPublicKey,
			        redirectUrl: `${window.location.origin}${self.formPay.redirectUrl}${self.formPay.wompiReference}`
			      });
			      self.executeWompi();
			    })
			    .catch( err => {
			      console.log(err);
			    });
			},
			executeWompi(){
			    var self = this;
			    self.saveOrder(true,this.formPay.wompiReference,true);
			    this.checkout.open(function ( result ) { 
			      var transaction = result.transaction
			      if(transaction.status == 'APPROVED'){
			        self.sendWhatsApp(true,transaction.id, false,true);
			      }else{
			        self.form.forma_pago = 0;
			        self.checkout = false; 
			      }
			    });
			},
			domicilio(){
				$(".recoger").removeClass("selected-button");
				$(".domi").addClass("selected-button");
				this.valor_domicilio = this.domi_aux;
				this.status_recogerlo = false;
				this.form.domicilio = this.domi_aux;
				this.form.direccion = "";
				this.setTotalOrder();
			},
			recogerlo(){
				$(".domi").removeClass("selected-button");
				$(".recoger").addClass("selected-button");
				this.valor_domicilio = 0;
				this.status_recogerlo = true;
				this.form.direccion = "Recogerlo";
				this.form.domicilio = 0;
				this.setTotalOrder();
			},
			ValidateCoupon(){
				var self = this;
				this.coupon.id_companie = this.form.id_companie;
				this.coupon.coupon = this.coupon_value;
				this.coupon.total = this.total_order;
				if (this.valor_domicilio > 0) this.coupon.total -= this.valor_domicilio;
				this.couponText = '';
				this.coupon.cart = JSON.stringify(this.list_cart);
				$('.send-cupon .fa-paper-plane').hide();
				$('.fa-check').hide();
				$('.check-image .fa-times').hide();
				$('.fa-spinner').show();
				$('.fa-spinner').addClass('animation');
				axios
		        .post('https://back.vinapp.co/api/get-coupon-client',this.coupon)
		        .then((res) => {
			        if(res.data.statusCode == 200){
			          $('.fa-spinner').hide();
			          $('.status-cop').addClass('green');
			          $('.check-image').removeClass('wrong-coupon');
			          $('.status-cop').show();		
			          $('.check-image').addClass('success-coupon');
			          $('.check-image .fa-times').hide();
			          $('.fa-check').show();
			          setTimeout(function(){ self.status_coupon = false; }, 2000);
			          setTimeout(function(){ $('.status-cop').hide(); }, 2000);	
			          this.list_cart = JSON.parse(res.data.cart);
			          localStorage.setItem(`Cart_ ${this.form.id_companie}`,res.data.cart);   
			          this.couponSuccess = true;
			          this.couponText = res.data.statusText;
			          this.form.id_coupon = res.data.id_coupon;
			          localStorage.setItem("id_coupon", res.data.id_coupon);
			          localStorage.setItem("coupon_text", this.coupon.coupon);          
			          this.form.descuento = res.data.valueCoupon;
			          localStorage.setItem("order_discount", res.data.valueCoupon);
			          this.total_order = this.total_order - parseFloat(res.data.valueCoupon);
			          this.resetLocal();		          
			        }else{
			          $('.send-cupon .fa-paper-plane').show();	
			          $('.fa-spinner').hide();	
			          $('.status-cop').show();
			          $('.status-cop').removeClass('green');
			          $('.status-cop').addClass('red');
			          $('.check-image').addClass('wrong-coupon');
			          $('.check-image .fa-times').show();
			          $('.fa-check').hide();	         
			          this.couponError = true;
			          this.couponText = res.data.statusText;
			          setTimeout(function(){ $('.status-cop').hide(); }, 2000);
			        }
			    })
			    .catch((err) => {
			      console.log(err);
			    });
			},
			clearAll(){
				$('.send-cupon .fa-paper-plane').show();
				this.total_order += this.form.descuento;
				this.list_cart.forEach((item) => {
					item.descuento = 0;
				});	
				localStorage.removeItem("id_coupon");
			    localStorage.removeItem("coupon_text");
			    localStorage.removeItem("order_discount");
			    this.form.descuento = 0;
			    this.coupon_value = "";
			    this.form.id_coupon = "";
			    this.coupon.id_coupon = "";
			    this.resetLocal();
			},
			resetLocal(){
				if (localStorage.getItem('id_coupon') && localStorage.getItem('coupon_text')) {
					this.coupon.id_coupon = localStorage.getItem('id_coupon');
					this.coupon_value = localStorage.getItem('coupon_text');
					$('.send-cupon .fa-times').show();
					$('.send-cupon .fa-paper-plane').hide();
				}else{
					$('.send-cupon .fa-times').hide();
					$('.send-cupon .fa-paper-plane').show();
					$('.check-image').removeClass('wrong-coupon');
					$('.check-image').removeClass('success-coupon');
				}
			},
			copyAccount(){      
		        document.getElementById('notify-copy').style.display = 'block';
		        setTimeout(function(){ document.getElementById('notify-copy').style.display = 'none'; }, 3000);            
		        var aux = document.createElement("input");
		        aux.setAttribute("value", document.getElementById('select-bank').value);
		        document.body.appendChild(aux);
		        aux.select();
		        document.execCommand("copy");
		        document.body.removeChild(aux);  
    		},
			close(){
  				this.$emit('closeCheckout',false);
  			},
  			show(){
  				console.log(this.form.gift);
  			},
  			verifyPayment(){
  				this.checkout = false;
  				if (this.form.forma_pago == 38) {
  					this.bank_transfer = true;
  				}else{
  					this.bank_transfer = false;
  				}
  				if(this.form.forma_pago == 76) this.checkout = true;
  			},
  			saveApiConversion(uri,event,valor){
	           let data={
	            uri:uri,
	            event:event,
	            valor:valor
	           }
	           axios.post('https://back.vinapp.co/api/api-conversion',data)
	           .then(res=>{
	              console.log(res.data)
	           }).catch(err=>{

	           });
	        }, 
  			saveOrder(pay_online,wp_reference = "",wp_wapp = false){
  				var _self = this;
  				this.url_imagen = "";
  				if(!this.validateShields()){
  					this.statusValidation = true;
  					$(window).scrollTop(0);
  					return false;
  				}
  				if (localStorage.getItem('id_coupon'))this.form.descuento = JSON.parse(localStorage.getItem('order_discount'));
  				this.statusValidation = false;
  				this.form.total = this.total_order;
  				this.saveApiConversion(this.$route.params.id,'InitiateCheckout',this.total_order);
  				this.form.domicilio = this.valor_domicilio;
  				this.form.cart = localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`);  
  				var data = new FormData();
  				data.append('id_companie',this.form.id_companie);
  				data.append('nombre',this.form.nombre);
  				data.append('cedula',this.form.cedula);			
  				data.append('email',this.form.email);
  				data.append('telefono',this.form.telefono);
  				data.append('direccion',this.form.direccion);
  				data.append('forma_pago',this.form.forma_pago);
  				if(this.ciudades_entrega.length > 0)data.append('ciudad_entrega',this.ciudad_entrega);
  				data.append('domicilio',this.valor_domicilio);
  				data.append('status_gift',this.form.status_gift);
  				data.append('entrega',this.form.fecha_entrega);
  				data.append('os',this.nameOS);
  				data.append('fecha_nacimiento',this.form.fecha_nacimiento);
  				data.append('descuento',this.form.descuento);
  				data.append('id_coupon',this.form.id_coupon);
  				data.append('latitude', this.latitude);
  				data.append('longitude', this.longitude);
				data.append('id_point', this.form.id_point);
  				if(this.status_map) data.append('id_zone', this.id_zone);
  				if(this.form.gift){
  					data.append('gift',JSON.stringify(this.form.gift));
  					data.append('imagen',this.form.gift.imagen);	
  				}else{
  					data.append('gift',null);
  					data.append('imagen',null);
  				}
  				
  				data.append('total',this.total_order);  				
  				data.append('cart',localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
  				data.append('wp_reference', wp_reference);
  				if(wp_wapp){
  					data.append('wp_wapp', this.sendWhatsApp(false,null,true));
  				}

			    axios.post('https://back.vinapp.co/api/order/save-order-ecommerce2',data)
			    .then(res => {
			    	this.url_imagen = res.data.imagen_regalo;
			    	if(!pay_online){
			    		_self.saveApiConversion(_self.$route.params.id,'Purchase',_self.total_order);
			    		_self.sendWhatsApp(false)
			    	}
			    })
			    .catch(err => {
			        console.log(err);      
			    });
  			},
  			validateShields(){
  				let status = true;
  				//NOMBRE
  				if(!this.form.nombre){
  					$("#nombre").addClass('empty-shield');status = false;		
  				}else {
  					$("#nombre").removeClass('empty-shield');	
  				}
  				//TELEFONO
  				if(!this.form.telefono){
  					$("#telefono").addClass('empty-shield');status = false;		
  				}else {
  					$("#telefono").removeClass('empty-shield');	
  				}

  				//CEDULA
  				if(!this.form.cedula && this.cedula_company){
  					$("#cedula").addClass('empty-shield');status = false;		
  				}else {
  					$("#cedula").removeClass('empty-shield');	
  				}

  				//EMAIL
  				if(!this.form.email && this.email_company){
  					$("#email").addClass('empty-shield');status = false;		
  				}else {
  					$("#email").removeClass('empty-shield');	
  				}

  				//DIRECCION
  				if(!this.form.direccion && !this.status_recogerlo){
  					$("#direccion").addClass('empty-shield');status = false;		
  				}else {
  					$("#direccion").removeClass('empty-shield');	
  				}

  				//METODO DE PAGO
  				if(this.form.forma_pago == 0){
  					$("#forma_pago").addClass('empty-shield');status = false;		
  				}else {
  					$("#forma_pago").removeClass('empty-shield');	
  				}

				if(this.form.id_point == 0){
  					$("#id_point").addClass('empty-shield');status = false;		
  				}else {
  					$("#id_point").removeClass('empty-shield');	
  				}

  				if(this.ciudades_entrega.length > 0){
  					if(this.ciudad_entrega == 0){
						$("#ciudad_entrega").addClass('empty-shield');status = false;
  					}else{
  						$("#ciudad_entrega").removeClass('empty-shield');	
  					}
  				}
  				return status;	
  			},
  			sendWhatsApp(wompi,wompi_id = "",retornar = false){
  				let total_discount = localStorage.getItem('order_discount') ? JSON.parse(localStorage.getItem('order_discount')) : 0;
  				if (localStorage.getItem('id_coupon')) {
					localStorage.removeItem('id_coupon');
					localStorage.removeItem('order_discount');
				}
  				this.form.cart = JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
  				this.mensaje = "";
  				this.mensaje = '';			      
			    let nombre_comercial = localStorage.getItem('Nombre_comercial');
			    nombre_comercial = nombre_comercial.replace(" ","%20");
			    let nombre = this.form.nombre;
			    localStorage.setItem('nombre',nombre);
			    let telefono = this.form.telefono;
			    localStorage.setItem('telefono',telefono);
			    if(this.email_company)localStorage.setItem('email',this.form.email);
			    if(this.cedula_company)localStorage.setItem('cedula',this.form.cedula);			   
			    nombre = nombre.replace(" ","%20");     
				const puntoSeleccionado = this.points.find(point => point.id_point === this.form.id_point);
				if (puntoSeleccionado) {
					this.telefono_pedidos = puntoSeleccionado.telefono_pedidos;
				} else {
				// Si no se encuentra el punto seleccionado, colocamos el local
					this.telefono_pedidos = localStorage.getItem('Telefono_pedidos');
				}
			    var value = 0;
			    var reemplazar="";
			    this.mensaje += `
			     https://wa.me/${this.telefono_pedidos}?text=Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20una%20compra.`;
			     let direccion = this.form.direccion;
			     if(this.form.direccion != "Recogerlo" ){
			     	localStorage.setItem('direccion',direccion);
			     }
			     let direccion_pedido = '';
			     direccion = direccion.replace("#",'%23');
			     direccion = direccion.split(' ');
			     let tamaño = direccion.length;
		         direccion.forEach((parte,index)=>{
		            index += 1;
		            if(index < tamaño){
		              direccion_pedido += `${parte}%20`
		            }else{
		              direccion_pedido += `${parte}`
		            }
		         });  
			     this.mensaje += '%0A%0A';
			     if(!this.status_recogerlo){
			     	this.mensaje += `*Dirección:*%20${direccion_pedido}`;
			     } 
			     if(this.cedula_company){
			        this.mensaje += '%0A';//un espacio  
			         this.mensaje +=  `*Cédula:*%20${this.form.cedula}`;
			     } 
			      if(this.email_company){
			        this.mensaje += '%0A';//un espacio  
			         this.mensaje +=  `*Email:*%20${this.form.email}`;
			      }

			      if(this.born_date){
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje +=  `*Fecha de nacimiento:*%20${this.form.fecha_nacimiento}`;  
			      } 

			      if(this.deliver_date && !this.delivery_time){
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje +=  `*Fecha de entrega:*%20${this.form.fecha_entrega}`;
			      }

			      if(this.delivery_time){
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje +=  `*Fecha de entrega:*%20${this.form.fecha_entrega}`;
			      }


			      if(this.form.gift)    {
			      	this.mensaje += '%0A%0A';//dos espacio
			      	this.mensaje += '*Información de Entrega*';
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje += '*Entregar a:*%20'+this.form.gift.reciber_name;
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje += '*Celular de quien recibe:*%20'+this.form.gift.reciber_phone;
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje += '*Día de entrega:*%20'+this.form.gift.delivery_day;
			      	this.mensaje += '%0A';//un espacio
			      	let direccion_entrega = '';
			      	let direccion2 = this.form.gift.reciber_adress;
				     direccion2 = direccion2.replace("#",'%23');
				     direccion2 = direccion2.split(' ');
				     let tamaño = direccion2.length;
			         direccion2.forEach((parte,index)=>{
			            index += 1;
			            if(index < tamaño){
			              direccion_entrega += `${parte}%20`
			            }else{
			              direccion_entrega += `${parte}`
			            }
			        });
			      	this.mensaje += '*Dirección de entrega:*%20'+direccion_entrega;
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje += '*Barrio:*%20'+this.form.gift.reciber_place;
			      	if (this.form.gift.delivery_hour == null || this.form.gift.delivery_hour == 'null'){
			      		
			      	}else{
			      		this.mensaje += '%0A';//un espacio
			      		this.mensaje += '*Hora de entrega:*%20'+this.form.gift.delivery_hour;
			      	}
			      	this.mensaje += '%0A';//un espacio
			      	this.mensaje += '*Mensaje:*%20'+this.form.gift.delivery_message;
			      	this.mensaje += '%0A';//un espacio
			      	let firma = 'No';
			      	if(this.form.gift.firm)firma = 'Si';
			      	this.mensaje += '*la tarjeta se firma con tu nombre?*%20'+firma;
			      	this.mensaje += '%0A';//un espacio
			      	if(this.url_imagen){			      		
			      		this.mensaje += '*Imagen de muestra:*%20';
			      		this.mensaje += '%0A';//un espacio
			      		this.mensaje += this.url_imagen;
			      		this.mensaje += '%0A';//un espacio
			      	}
			      }
			      this.mensaje += '%0A';//un espacio
			      this.mensaje += '*Celular:*%20'+this.form.telefono;
			      this.mensaje += '%0A%0A';
			      this.mensaje += '*Detalle de la orden:*';
			      this.mensaje += '%0A';
			      
			      this.form.cart.forEach((item)=>{
			      value = 0;
			      this.mensaje += `-%20${item.quantity}%20x%20`;
			      reemplazar = item.name;
			      reemplazar = reemplazar.replace(" ","%20");
			      value = (parseInt(item.value_sale)*item.quantity)
			      if(item.combination)this.mensaje += `-%20${reemplazar}%20(${item.combination})%20(%24%20${new Intl.NumberFormat("de-DE").format(value)})`;
				  else this.mensaje += `-%20${reemplazar}%20(%24%20${new Intl.NumberFormat("de-DE").format(value)})`;			      
			      this.mensaje += '.%0A%0A';
			      });
			      if(this.form.descuento > 0){
			        this.mensaje += `*Descuento%3A*%20%24%20${new Intl.NumberFormat("de-DE").format(this.form.descuento)}`;
			        this.mensaje += '%0A%0A'; 
     			  }
			      //validamos el domicilio
			      if(this.form.domicilio > 0){      
			      this.mensaje += `*Envío a domicilio:*%20%24%20${this.form.domicilio}`;
			      this.mensaje += '.%0A';
			      }
			      var textForma = this.form.forma_pago;    
			      localStorage.setItem('forma_pago',textForma);
			      this.formasPago.forEach(function(f){
			          if(textForma == f.id)textForma = f.text;
			      });

			      if(this.ciudades_entrega.length > 0){
			      	  //definimos la ciudad de entrega
				      this.mensaje += `*Ciudad de Entrega%3A*%20${this.ciudad_entrega}`;
				      this.mensaje += '%0A';
			      }
			      //definimos la forma de pago.      
			      this.mensaje += `*Forma de Pago%3A*%20${textForma}`;
			      this.mensaje += '%0A';
			      this.mensaje += `*Total del pedido%3A%20%24%20${new Intl.NumberFormat("de-DE").format(this.total_order)}*`;
			      this.mensaje += '%0A';    
			      
			      if(wompi && !retornar){
			        this.mensaje += `*Pago en Wompi*`; 
			        this.mensaje += '%0A';
			        this.mensaje += `*Id de la transacción%3A*%20${wompi_id}`;
			        //this.mensaje += `*Referencia de pago%3A*%20${this.formPay.wompiReference}`;
			        this.mensaje += '%0A%0A'; 
			        this.form.forma_pago = 0;
			        this.checkout = false;  
			      }

			      if(retornar){
			        this.mensaje += `*Pago en Wompi*`; 
			        this.mensaje += '%0A';
			        this.mensaje += `*Id de la transacción%3A*%20reemplazar`;
			        this.mensaje += '%0A%0A'; 
			      }

			      if (this.status_map) {
			        if (this.valor_domicilio > 0 ) {
			          this.mensaje +=  `*Nombre de la zona%3A*%20${this.zone_name}`;
			          this.mensaje += '%0A';
			          if (this.latitude != 'No' && this.longitude != 'No') {
			            this.mensaje +=  `(https://www.google.com/maps?q=${this.latitude},${this.longitude})`;
			          }
			          this.mensaje += '%0A';
			        }
			      }

			      this.mensaje += `*Comentario%3A*%20${this.form.comentario}`;
			      this.mensaje += '%0A%0A';
			      if(this.form.domicilio == 0 && !this.status_recogerlo){
			      	this.mensaje += `El valor del domicilio será confirmado en un momento de acuerdo a la dirección`;
			      	this.mensaje += '.%0A%0A';
			      }
			      //preguntamos si la persona desea recoger el pedido en el local
			      if(this.status_recogerlo){
			      	this.mensaje += `Para%20recoger%20en%20el%20local.`;
			      	this.mensaje += '%0A';
			      }
			      this.mensaje += `Gracias.`;	
			      if(retornar)return this.mensaje;
			      localStorage.removeItem(`Cart_ ${localStorage.getItem('id_companie')}`);		      
			      location.href = this.mensaje;
  					
  			},
			setTotalOrder(){
				this.total_order = 0;
				this.list_cart.forEach((item) => {
					this.total_order += (parseInt(item.value_sale) * item.quantity);
				})
				this.subtotal = this.total_order;
				this.total_order += this.valor_domicilio;
			}
		},
		mounted(){
			this.getListPoints();
			var self = this;
			console.log(this.ciudades_entrega);
			var drinkSelect = document.getElementById('id_btn_confirmar');
			setTimeout(function(){
	         drinkSelect.disabled = true; 
	        }, 500);
			setTimeout(function(){
		      self.initMap();
		    },2000);
		    if(this.delivery_time){		    	
		    	if(this.hora_actual >= 8 && this.hora_actual <= 18){
		    		let mañana = moment().add(1, 'days');
		    		//mañana = moment(mañana).format('YYYY-MM-DD');
		    		this.min_date = mañana;
		    	}else{
		    		let pasado_mañana = moment().add(2, 'days');
		    		//pasado_mañana = moment(pasado_mañana).format('YYYY-MM-DD');
		    		this.min_date = pasado_mañana;
		    	}
		    }


		    var picker3 = new Pikaday({
		        field: document.getElementById('nacimiento'),
		        format: 'YYYY-MM-DD',
		        yearRange: [1960,2010],
		        toString(date, format) {
		        	console.log(date, format)
		        	console.log("juancho")
			        // you should do formatting based on the passed format,
			        // but we will just return 'D/M/YYYY' for simplicity
			        const day = moment(date).format("DD");
			        const month = moment(date).format("MM");
			        const year = moment(date).format("YYYY");
			        self.form.fecha_nacimiento=year+'-'+month+'-'+day;
			        return `${day}/${month}/${year}`;
			    }
		    });

		    var picker = new Pikaday({
		        field: document.getElementById('fecha_entrega'),
		        format: 'YYYY-MM-DD',
		        minDate: self.min_date._d,
		        toString(date, format) {
		        	console.log(date, format)
			        // you should do formatting based on the passed format,
			        // but we will just return 'D/M/YYYY' for simplicity
			        const day = moment(date).format("DD");
			        const month = moment(date).format("MM");
			        const year = moment(date).format("YYYY");
			        self.form.fecha_entrega=year+'-'+month+'-'+day;
			        return `${day}/${month}/${year}`;
			    }
		    });

		    var picker2 = new Pikaday({
		        field: document.getElementById('fecha_entrega_2'),
		        format: 'YYYY-MM-DD',
		        weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
		        minDate: self.min_date._d,
		        toString(date, format) {
		        	console.log(date, format)
			        // you should do formatting based on the passed format,
			        // but we will just return 'D/M/YYYY' for simplicity
			        const day = moment(date).format("DD");
			        const month = moment(date).format("MM");
			        const year = moment(date).format("YYYY");
			        self.form.fecha_entrega=year+'-'+month+'-'+day;
			        return `${day}/${month}/${year}`;
			    }
		    });


			if(this.recoger){
				$('.person-data').addClass("custom-content");
			}else{
				$('.person-data').removeClass("custom-content");
			}
			this.domi_aux = this.valor_domicilio;
			this.domicilio();
			$('.status-cop').hide();
			$('.check-image .fa-times').hide();
			$('.fa-spinner').hide();
			$('.send-cupon .fa-times').hide();
			//$('.fa-spinner').addClass('animation');
			this.setTotalOrder();
			this.resetLocal();
			let total_discount = localStorage.getItem('order_discount') ? JSON.parse(localStorage.getItem('order_discount')) : 0;
			this.resetLocal();
			if (localStorage.getItem('id_coupon') && localStorage.getItem('coupon_text')){
				this.coupon.id_coupon = localStorage.getItem('id_coupon');
				this.coupon_value = localStorage.getItem('coupon_text');
				this.ValidateCoupon();
			}
			this.email_company = JSON.parse(localStorage.getItem('Email-checkout'));
			this.cedula_company = JSON.parse(localStorage.getItem('Cedula-checkout'));		
			this.cash = JSON.parse(localStorage.getItem('cash'));
			this.transfer = JSON.parse(localStorage.getItem('transfer'));
			this.dataphone = JSON.parse(localStorage.getItem('dataphone'));	

			let nombreStorage = localStorage.getItem('nombre');
			if (nombreStorage)this.form.nombre = nombreStorage;

			let phoneStorage = localStorage.getItem('telefono');
			if (phoneStorage)this.form.telefono = phoneStorage;

			let emailStorage = localStorage.getItem('email');
			if (emailStorage)this.form.email = emailStorage;

			let direccionStorage = localStorage.getItem('direccion');
			if (direccionStorage)this.form.direccion = direccionStorage;

			let cedulaStorage = localStorage.getItem('cedula');
			if (cedulaStorage)this.form.cedula = cedulaStorage;

			$(".send-button").click(function(){
			  $(".send-button").addClass("button-loading");
			  $(".button-loading").removeClass("send-button");
			  $(".button-loading").addClass("rodar");
			  $(".send-text").addClass("hide");
			  $(".what").addClass("hide");
			  setTimeout(function() { 
			   $(".fa-check").removeClass("hide");
			   $(".button-loading").removeClass("rodar");
			  }, 3000);
			});

			if(!this.status_map){
				const ubicacion_success = function(ubicacion) {
		          console.log(ubicacion)
		          if (ubicacion) {
		            const lat = ubicacion.coords.latitude;
		            const lng = ubicacion.coords.longitude;        
		            self.latitude = lat;
		            self.longitude = lng;
		          }
	        	}
		        const ubicacion_error = function(error) {          
		          console.log(error)
		        }   
		        //solo para domicilios
		        if(navigator.geolocation) {
		          navigator.geolocation.getCurrentPosition(ubicacion_success,ubicacion_error);
		        }
			}else{
				self.openMapDetail();
			}
		}
	}
</script>


